import { InjectionToken } from '@angular/core';

import { ISTacticsEnum } from '../enums';

export const IS_TACTICS_RESOURCE_PATH = new InjectionToken<ISTacticsEnum>('ResourcePath');
